import type { IBenefitWindow } from '@ben/shared/types/columbia';

export enum WindowTriggerType {
  RULE_BASED = 'RULE_BASED',
  DATE_RANGE = 'DATE_RANGE',
}

export enum ApprovalSetting {
  AUTO_APPROVE = 'auto_approve',
  REQUIRE_ADMIN_APPROVAL = 'require_admin_approval',
}

export interface LifeEventFormValues {
  lifeEventPolicies?: {
    id?: number;
    lifeEventTypes: string[];
    approvalSetting: ApprovalSetting;
    windows: IBenefitWindow[];
    componentRestrictions?: {
      stepId: number;
      componentId: number;
      enabled: boolean;
      restrictionSet?: Record<string, unknown>;
    }[];
  }[];
}
